/* eslint class-methods-use-this: 0 no-param-reassign: 0 */
import { JsonPropertiesMapper } from 'jsona';

export default class MyJsonPropertiesMapper extends JsonPropertiesMapper {
  setAttributes(model, attributes) {
    this.kebabCaseToCamelCase(model, attributes);
  }

  setRelationships(model, relationships) {
    this.kebabCaseToCamelCase(model, relationships);
  }

  kebabCaseToCamelCase(model, values) {
    Object.keys(values).forEach(propName => {
      const hasNested =
        values[propName] && Object.prototype.toString.call(values[propName]) === '[object Object]';

      if (hasNested) {
        this.convertNested(values[propName]);
      }
      const camelName = this.convertToCamelCaseFromKebabCase(propName);

      model[camelName] = values[propName];
    });
  }

  convertNested(values) {
    Object.keys(values).forEach(propName => {
      const camelName = this.convertToCamelCaseFromKebabCase(propName);

      if (camelName === propName) return;

      Object.defineProperty(values, camelName, Object.getOwnPropertyDescriptor(values, propName));
      delete values[propName];
    });
  }

  convertToCamelCaseFromKebabCase(string) {
    return string.replace(/-([a-z])/g, g => g[1].toUpperCase());
  }
}
